import api from "./api";

export const chatApi = {
    getChatRooms: async () => {
        const response = await api.get('/chat/chatrooms');
        return response.data;
    },
    getRoomMessages: async (roomId) => {
        const response = await api.get(`/chat/chatrooms/${roomId}/messages`);
        return response.data;
    },
    sendMessage: async (roomId, message, image = null) => {
        const payload = {
            message,
            image: image // Base64 encoded image if present
        };
        const response = await api.post(`/chat/chatrooms/${roomId}/messages`, payload);
        return response.data;
    },
    createChatRoom: async (name = "New Chat Room") => {   
        const response = await api.post('/chat/chatrooms', { name });
        return response.data;
    }
}
